import { useEffect, useState } from "react";

export const useTimeLeft = ({ expiry }: { expiry: string | number }) => {
  const timeLeftInSec = Math.ceil(
    (new Date(expiry).getTime() - Date.now()) / 1000
  );
  const [delta, setDelta] = useState(() =>
    timeLeftInSec > 0 ? timeLeftInSec : 0
  );
  let diff = delta;
  const days = Math.floor(delta / 86400);
  diff -= days * 86400;
  const hours = Math.floor(diff / 3600) % 24;
  const _hours = `0${hours}`.slice(-2);
  diff -= hours * 3600;
  const minutes = Math.floor(diff / 60) % 60;
  const _minutes = `0${minutes}`.slice(-2);
  diff -= minutes * 60;
  const seconds = `0${Math.floor(diff % 60)}`.slice(-2);

  useEffect(() => {
    const id = setInterval(() => {
      setDelta((delta) => (delta > 0 ? delta - 1 : 0));
    }, 1000);

    return () => {
      if (id) {
        clearInterval(id);
      }
    };
  }, []);

  return { days, hours: _hours, minutes: _minutes, seconds };
};
